import React from 'react';
import Skeleton from 'react-loading-skeleton';

const CustomSelectSkeleton: React.FC = () => {
    return (
        <div className="custom-select custom-select__skeleton">
            <span className="custom-select__label semibold">
                <span className="unstyled notifications-settings__salary-notifications__select-label">
                    <span className="semibold notifications-settings__salary-notifications__main-select-label">
                        <Skeleton height={21} width={100} />
                    </span>
                </span>
            </span>
            <div className="custom-select__focus-wrapper">
                <div className="focus-container custom-select__focus-container">
                    <Skeleton height={65} width="100%" />
                </div>
            </div>
        </div>
    );
};

export default CustomSelectSkeleton;
